import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tours/page.tsx");
